// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentLoader_wrapper__jgAcu","loading":"ContentLoader_loading__Yl6z9","content":"ContentLoader_content__o91zg","loader":"ContentLoader_loader__bA970"};